import React from 'react';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive.js';

const InformationContainer = styled.div`
  width: 400px;
  display: flex;
  gap: 24px;
  flex-direction: column;

  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
`;

const SubInformationContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: 600;
`;

const Info = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text.regular};
`;

const Information = () => {
  return (
    <InformationContainer>
      <SubInformationContainer>
        <Title>Customization of Gift Card Style</Title>
        <Info>
          Personalize the card with a unique design and message to make your
          gift even more special.
        </Info>
      </SubInformationContainer>
      <SubInformationContainer>
        <Title>Payment Options</Title>
        <Info>
          Complete your purchase using either a credit card or your balance. We
          accept all major credit cards through Stripe.
        </Info>
      </SubInformationContainer>
      <SubInformationContainer>
        <Title>How It Works</Title>
        <Info>
          Once you purchase a gift card, it's instantly delivered via email to
          the recipient. They don’t need to pay anything — claiming the gift is
          completely free.
        </Info>
      </SubInformationContainer>
    </InformationContainer>
  );
};

export default Information;
